const NotificationEventTypes = {
  ADD: 1,
  UPDATE: 2,
  DELETE: 3,
  UPLOAD: 4,
  DOWNLOAD: 5,
  ACCEPT: 6,
  APPROVE: 7,
  ASSIGN: 8,
  REJECT: 9,
  ATTACH: 10,
  FORWARD: 11,
  UNASSIGN: 12,
  EXPORT: 13,
  NEW_ADMISSION_RECEIVED: 14,
  CONFIRMATION: 15,
  MISSED: 16,
  WITHDRAW: 17,
  ABSENCE_DAILY: 18,
  ABSENCE_CONSECUTIVE: 19,
  EXPIRED: 20,
  REQUEST: 21,
  REMINDER: 22,
  CANCELLED: 23,
  ENROLLED: 24,
};

export default NotificationEventTypes;
